function buildUrl(fileName: string) {
  return `${process.env.PUBLIC_URL}/${fileName}`;
}

function getAlerts() {
  return fetch(buildUrl("alerts.json"))
    .then((response) => response.json())
    .then((data: Data.Alert[]) => data);
}

function getUniversalReport() {
  return fetch(
    buildUrl("covid-19-indiana-universal-report-current-public.json")
  )
    .then((response) => response.json())
    .then((data: Data.Vectorized) => ({
      data: data,
      reportDate: data.report_date,
    }));
}

function getLTCSites() {
  return fetch(buildUrl("ltc.json"))
    .then((response) => response.json())
    .then((data: Data.LTCSite[]) => data);
}

function getLTCData() {
  return fetch(buildUrl("covid-19-indiana-ltc-report-current-public.json"))
    .then((response) => response.json())
    .then((data: Data.Ltc) => ({
      data: data,
      reportDate: data.report_date,
    }));
}

function getOutliers() {
  return fetch(buildUrl("metric-outliers.json"))
    .then((response) => response.json())
    .then((data: Data.Outlier[]) => ({
      data: data,
    }));
}

function getSchools() {
  return fetch(buildUrl("covid-19-indiana-school-report.json"))
    .then((response) => response.json())
    .then((data: Data.SchoolReport) => data);
}

export {
  getAlerts,
  getUniversalReport,
  getLTCSites,
  getLTCData,
  getOutliers,
  getSchools,
};
